import { createAction } from 'redux-act';

import * as apps from '../../core/apps';

// ****
export const changeAppType = createAction(
  'change app type',
  (type) => type
);

export const changeAppFormName = createAction(
  'change app form name',
  (name) => name
);

export const saveApp = createAction(
  'save app to state',
  (data) => data
);

export const openAddPlacement = createAction(
  'open add placement modal',
);
export const closeAddPlacement = createAction(
  'close add placement modal',
);

export const openUpdatePostback = createAction(
  'open update postback modal',
);
export const closeUpdatePostback = createAction(
  'close update postback modal',
);

export const openUpdateSurveyPromotion = createAction(
  'open survey promotion modal',
);
export const closeUpdateSurveyPromotion = createAction(
  'close survey promotion modal',
);

export const openTestPostback = createAction(
  'open test postback modal',
);
export const closeTestPostback = createAction(
  'close test postback modal',
);

export const openAPIIntegration = createAction(
  'open request api integration modal',
);
export const closeAPIIntegration = createAction(
  'close request api integration modal',
);

export const openIFrameModal = createAction(
  'open iFrame modal',
);
export const closeIFrameModal = createAction(
  'close iFrame modal',
);
// ****

export const fetchApps = createAction(
  'get all apps',
);
export const fetchAppsSuccess = createAction(
  'get all apps success',
  (allApps) => allApps
);
export const fetchAppsFail = createAction(
  'get all apps fail',
  (error) => error
);

export const fetchAppsNames = createAction(
  'get apps names',
);
export const fetchAppsNamesSuccess = createAction(
  'get apps names',
  (ids) => ids
);
export const fetchAppsNamesFail = createAction(
  'get apps names fail',
  (error) => error
);

export const openAddAppModal = createAction(
  'open add app modal',
);
export const closeAddAppModal = createAction(
  'close add app modal',
);

export const addApp = createAction(
  'add new app',
);
export const addAppSuccess = createAction(
  'add new app success',
  (app) => app
);
export const addAppFail = createAction(
  'add new app fail',
  (error) => error
);

export const updateApp = createAction(
  'update app',
);
export const updateAppSuccess = createAction(
  'update app success',
  (app) => app
);
export const updateAppFail = createAction(
  'update app fail',
  (error) => error
);

export const parseAppFromUrl = createAction(
  'parse app from url',
  (url) => url
);
export const parseAppFromUrlSuccess = createAction(
  'parse app from url success',
  (data) => data
);
export const parseAppFromUrlFail = createAction(
  'parse app from url fail',
  (error) => error
);

export const fetchAppDetails = createAction(
  'get app details',
);
export const fetchAppDetailsSuccess = createAction(
  'get app details success',
  (app) => app
);
export const fetchAppDetailsFail = createAction(
  'get app details fail',
  (error) => error
);

export const updateUnitStatus = createAction(
  'update unit status',
);
export const updateUnitStatusSuccess = createAction(
  'update unit status success',
);
export const updateUnitStatusFail = createAction(
  'update unit status fail',
  (error) => error
);

export const addPlacement = createAction(
  'add placement',
);
export const addPlacementSuccess = createAction(
  'add placement success',
);
export const addPlacementFail = createAction(
  'add placement fail',
  (error) => error
);

export const updatePlacement = createAction(
  'update placement',
);
export const updatePlacementSuccess = createAction(
  'update placement success',
);
export const updatePlacementFail = createAction(
  'update placement fail',
  (error) => error
);

export const deletePlacement = createAction(
  'delete placement',
);
export const deletePlacementSuccess = createAction(
  'delete placement success',
);
export const deletePlacementFail = createAction(
  'delete placement fail',
  (error) => error
);

export const updatePlacementStatus = createAction(
  'update placement status',
);
export const updatePlacementStatusSuccess = createAction(
  'update placement status success',
);
export const updatePlacementStatusFail = createAction(
  'update placement status fail',
  (error) => error
);

export const updatePostback = createAction(
  'update postback',
);
export const updatePostbackSuccess = createAction(
  'update postback success',
);
export const updatePostbackFail = createAction(
  'update postback fail',
  (error) => error
);

export const createApiRequest = createAction(
  'create api request',
);
export const createApiRequestSuccess = createAction(
  'create api request success',
);
export const createApiRequestFail = createAction(
  'create api request fail',
  (error) => error
);

export const updateSurveyPromotion = createAction(
  'update survey platform status',
);
export const updateSurveyPromotionSuccess = createAction(
  'update survey platform status success',
);
export const updateSurveyPromotionFail = createAction(
  'update survey platform status fail',
  (error) => error
);

export const openDefineNotLiveApp = createAction(
  'open define not live modal',
);
export const closeDefineNotLiveApp = createAction(
  'close define not live modal',
);

export const updatePlacementFromSocket = createAction(
  'update placement from socket',
);

export const openAddStoreUrlModal = createAction(
  'open add store url modal',
);
export const closeAddStoreUrlModal = createAction(
  'close add store url modal',
);

export const reducer = {
  [fetchApps]: (state, payload) =>
    apps.fetchApps(state, payload),
  [fetchAppsSuccess]: (state, payload) =>
    apps.fetchAppsSuccess(state, payload),

  [fetchAppsNames]: (state, payload) =>
    apps.fetchAppsNames(state, payload),
  [fetchAppsNamesSuccess]: (state, payload) =>
    apps.fetchAppsNamesSuccess(state, payload),

  [openAddAppModal]: (state, payload) =>
    apps.openAddAppModal(state, payload),
  [closeAddAppModal]: (state, payload) =>
    apps.closeAddAppModal(state, payload),

  [addApp]: (state, payload) =>
    apps.addApp(state, payload),
  [addAppSuccess]: (state, payload) =>
    apps.addAppSuccess(state, payload),
  [addAppFail]: (state, payload) =>
    apps.addAppFail(state, payload),

  [updateApp]: (state, payload) =>
    apps.updateApp(state, payload),
  [updateAppSuccess]: (state, payload) =>
    apps.updateAppSuccess(state, payload),
  [updateAppFail]: (state, payload) =>
    apps.updateAppFail(state, payload),

  [parseAppFromUrl]: (state, payload) =>
    apps.parseAppFromUrl(state, payload),
  [parseAppFromUrlSuccess]: (state, payload) =>
    apps.parseAppFromUrlSuccess(state, payload),
  [parseAppFromUrlFail]: (state, payload) =>
    apps.parseAppFromUrlFail(state, payload),

  [changeAppType]: (state, payload) =>
    apps.changeAppType(state, payload),

  [changeAppFormName]: (state, payload) =>
    apps.changeAppFormName(state, payload),

  [saveApp]: (state, payload) =>
    apps.saveApp(state, payload),

  [fetchAppDetailsSuccess]: (state, payload) =>
    apps.fetchAppDetailsSuccess(state, payload),

  [updateUnitStatusSuccess]: (state, payload) =>
    apps.updateUnitStatusSuccess(state, payload),

  [openAddPlacement]: (state, payload) =>
    apps.openAddPlacement(state, payload),
  [closeAddPlacement]: (state, payload) =>
    apps.closeAddPlacement(state, payload),

  [openUpdatePostback]: (state, payload) =>
    apps.openUpdatePostback(state, payload),
  [closeUpdatePostback]: (state, payload) =>
    apps.closeUpdatePostback(state, payload),

  [openUpdateSurveyPromotion]: (state, payload) =>
    apps.openUpdateSurveyPromotion(state, payload),
  [closeUpdateSurveyPromotion]: (state, payload) =>
    apps.closeUpdateSurveyPromotion(state, payload),

  [openAPIIntegration]: (state, payload) =>
    apps.openAPIIntegration(state, payload),
  [closeAPIIntegration]: (state) =>
    apps.closeAPIIntegration(state),

  [openIFrameModal]: (state, payload) =>
    apps.openIFrame(state, payload),
  [closeIFrameModal]: (state) =>
    apps.closeIFrame(state),

  [openTestPostback]: (state, payload) =>
    apps.openTestPostback(state, payload),
  [closeTestPostback]: (state, payload) =>
    apps.closeTestPostback(state, payload),

  [addPlacement]: (state, payload) =>
    apps.addPlacement(state, payload),
  [addPlacementSuccess]: (state, payload) =>
    apps.addPlacementSuccess(state, payload),

  [updatePlacement]: (state, payload) =>
    apps.updatePlacement(state, payload),
  [updatePlacementSuccess]: (state, payload) =>
    apps.updatePlacementSuccess(state, payload),

  [deletePlacementSuccess]: (state, payload) =>
    apps.deletePlacementSuccess(state, payload),

  [updatePlacementStatusSuccess]: (state, payload) =>
    apps.updatePlacementStatusSuccess(state, payload),

  [updateSurveyPromotionSuccess]: (state, payload) =>
    apps.updateSurveyPromotionSuccess(state, payload),

  [updatePostbackSuccess]: (state, payload) =>
    apps.updatePostbackSuccess(state, payload),

  [createApiRequestSuccess]: (state, payload) =>
    apps.updatePlacementSuccess(state, payload),

  [updatePlacementFromSocket]: (state, payload) =>
    apps.updatePlacementFromSocket(state, payload),

  [openDefineNotLiveApp]: (state, payload) =>
    apps.openDefineNotLiveApp(state, payload),
  [closeDefineNotLiveApp]: (state, payload) =>
    apps.closeDefineNotLiveApp(state, payload),

  [openAddStoreUrlModal]: (state, payload) =>
    apps.openAddStoreUrlModal(state, payload),
  [closeAddStoreUrlModal]: (state, payload) =>
    apps.closeAddStoreUrlModal(state, payload),
};



/** WEBPACK FOOTER **
 ** ./js/redux/modules/apps.module.js
 **/